import CoreBase from '../../../services/engines/CoreBase';
import responseHelper from '../../../services/ResponseHelper';
import templateService from '../../../services/TemplateService';

const _name = 'TemplateFetcher';

class TemplateFetcher extends CoreBase {
    /**
     * Fetches all approved templates from BE.
     * @returns {Promise<object[]|null>} array of template notes, or null on failure
     */
    fetch = async () => {
        try {
            const resp = await templateService.getTemplates();

            if (responseHelper.check(resp, 'fetch', _name) < 0) {
                return null;
            }

            return resp.data.items ?? null;
        } catch (error) {
            this.logError('fetch', error.message);
            return null;
        }
    };
}

const templateFetcher = new TemplateFetcher();
export default templateFetcher;
